import { render, staticRenderFns } from "./SystemRole.vue?vue&type=template&id=3cc9b937&scoped=true"
import script from "./SystemRole.vue?vue&type=script&lang=js"
export * from "./SystemRole.vue?vue&type=script&lang=js"
import style0 from "./SystemRole.vue?vue&type=style&index=0&id=3cc9b937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9b937",
  null
  
)

export default component.exports